export default __webpack_public_path__ + "static/media/tmdbLogo.1bc67bf8.svg";